import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ProductivityAccessService } from '../components/productivity/productivity-access.service';

/**
 * Blocks Productivity when the environment flag is off or the user has
 * no Productivity view actions.
 */
export const productivityModuleGuard: CanActivateFn = () => {
  const access = inject(ProductivityAccessService);
  access.refresh();
  if (!access.canSeeModule()) {
    return inject(Router).createUrlTree(['/dashboard', 'home']);
  }
  return true;
};
